import Action from "../actions";

export function toastrReducer(state = [[], []], action) {
    if (action.type === Action.SHOW_TOASTR) {
        return [
            [action.toastMsg, ...state[0]],
            [action.toastrMsgId, ...state[1]]
        ]
    }
    if (action.type === Action.CLOSE_TOASTR_BY_ID) {
        let arr_msg = [...state[0]];
        let arr_id = [...state[1]];
        let index = arr_id.indexOf(action.toastrMsgId);
        if (index !== -1) {
            arr_msg.splice(index, 1);
            arr_id.splice(index, 1);
            return [arr_msg, arr_id];
        } else
            return state

    }
    return state;
}
